<template>
    <div class="container">
        <div class="section">
            <img class="img" :src="imgObj.top">
        </div>

        <div class="ceiling-view" v-if="ceilingType" :class="{'ceiling-fixed':ceilingType}">
            <div class="ceiling-tab">
                <div class="tab-item"
                    v-for="(item, index) in tabList" :key="index"
                    :class="{'active-tab': activeTab === index}"
                    @click="changeTab(item,index)"
                >
                    <span>{{item.stage}}</span>
                    <div v-if="activeTab === index" class="bor" />
                </div>
            </div>
        </div>

        <div class="section" v-for="(item, index) in imgList" :key="index" :id="'section_' + index">
            <img class="img" :src="item">
            <button v-if="index === 2" class="btn-img-1" @click="JumpFn">
            </button>
        </div>

        <div class="sectione-main">
            <div class="main">
                <el-tabs v-model="activeName" @tab-click="changeTabs">
                    <el-tab-pane class="main-tab"
                        v-for="(item, index) in stageList" :key="index"
                        :label="item.stage" :name="index"
                    >
                        <div class="m">
                            <div class="m-title">
                                {{item.title}}
                            </div>
                            <img class="main-icon" src="https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png">
                            <div class="main-t">
                                <div class="m-b">
                                    学习目标
                                </div>
                                <img @click="seeDetail(item)" class="detail" src="https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png">
                            </div>
                            <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" > {{v}}</div>
                            <div class="main-t">
                                <div class="m-b">
                                    实战项目
                                </div>
                            </div>
                            <div class="item" v-for="(v, i) in item.skillsList" :key="i" > {{v}}</div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>
                <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                <button class="jump-btn" @click="JumpFn('领取完整课程安排')">
                    <img :src="imgObj.btn1">
                </button>
            </div>
        </div>

        <div class="section">
            <!-- <img class="img" :src="imgObj.section1"> -->
            <img class="img" :src="imgObj.section2" id="section_S">
        </div>

        <div class="sw-section">
            <div class="swiper-container sw-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperList" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination sw-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>

        <div class="section">
            <img class="img" :src="imgObj.btn2">
            <button class="btn-img-1" @click="JumpFn('获取更多项目资料')">
            </button>
        </div>
        <div class="section">
            <img class="img" :src="imgObj.section3" id="section_F">
            <!-- <img class="img" :src="imgObj.section4" id="section_G"> -->
            <div class="section-btn4" @click="JumpFn('数据分析是一种能力')"></div>
        </div>
        <!-- <div class="section">
            <img class="img" :src="imgObj.section5" id="section_H">
        </div>
        <div class="sw-section1">
            <div class="swiper-container sw1-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperList1" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination sw1-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="section">
            <img class="img" :src="imgObj.section6">
        </div>
        <div class="sw-section2">
            <div class="swiper-container sw2-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperList2" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
            </div>
        </div> -->
        <div class="section">
            <img class="img" :src="imgObj.section7">
        </div>

      <div class="box box-fixed">
        <div class="box-inner" @click="JumpFn('名额有限立即抢占')">
          <div class="box10-content">
            <div class="box10-left">
              <img src="https://s21.lgstatic.com/growth/activity/20220610/1654846808855.png" alt="">
              咨询课程顾问 抢大额优惠券
            </div>
            <div class="box10-right" @click="JumpFn('名额有限立即抢占')">好课速享 马上抢占</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import mixin from '../../../common/js/mixins/repurchase'
import List from './data.js'
import activity from '../../../common/activity';
export default {
    mixins: [mixin],
    data() {
        return {
            List,
            activity,
            imgObj:{},
            imgList:[],
            tabList:[],
            swiperList:[],
            swiperList1:[],
            swiperList2:[],
            rankList:[],
            stageList:[],
            ceilingType:false,//吸顶tab
            activeTab:0,
            showData:{},
            showModal:false,
            courseId: '59',
            addressIdsMap: {
                "课程体系": "m1tv6",
                "实战项目": "n1tv7",
                "就业服务": "p1tv8",
                "用户评价": "q1tv9",
                "领取完整课程安排": "r1tva",
                "获取更多项目资料": "t1tvc",
                "名额有限立即抢占": "u1tvd",
                "数据分析是一种能力": "s1tvb"
            }
        };
    },
    mounted() {
        let dataList = this.List.data.pc
        this.imgObj = dataList.imgObj
        this.imgList = dataList.imgList
        this.swiperList = dataList.swiperList
        this.swiperList1 = dataList.swiperList1
        this.swiperList2 = dataList.swiperList2


        this.rankList = this.List.data.rankList
        this.tabList = this.List.data.tabList1
        this.stageList = this.List.data.stageList
        setTimeout(() => {
            // if(this.isAB) {
            //     this.eduPlatTrack('WebView', {
            //         'page_id': '1qjk',
            //         'page_from':'大课学习页',
            //     });
            // } else {
            //     this.eduPlatTrack('WebView', {
            //         'page_id': '1qjk',
            //     });
            // }
            this.platTrack('pcpv', {
                page_id: 'j1tyr',
            })
            this.swiperInit()
            this.renderSwiper()
            this.rangeSwipers();
        }, 500);
        window.addEventListener('scroll', this.scrollTopFn)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        changeTab(item,index) {
            this.activeTab = index
            let arr = [
                "#section_1",
                "#section_S",
                "#section_F",
                // "#section_G",
                // "#section_H"
            ]

            this.$el.querySelector(arr[index]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 100
            document.body.scrollTop = scroll - 100
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qjk',
            //     'button_name': item.stage
            // });
            this.platTrackClickFn(item.stage);
        },
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.ceilingType = scroll > 520 ? true : false; //吸顶tab
            let arr = [
                "section_1",
                "section_S",
                "section_F",
                // "section_G",
                // "section_H"
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 200) {
                    this.activeTab = index
                }
            })
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                pagination: '.sw-pagination',
                paginationClickable: true,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                spaceBetween: 30
            };
            this.$nextTick(() => {
                const swiper2 = new Swiper('.sw-wrap', option);
            });
            let option2 = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 26
            };
            const swiper3 = new Swiper('.sw2-wrap', option2);
        },
        seeDetail(val) {
            this.showModal = true;
            this.showData = val
        },
        close() {
            this.showModal = false;
        },
        changeTabs(val) {
            this.showModal = false
        },
        JumpFn(str) {
            // if(this.isAB) {
            //     this.eduPlatTrack('WebButtonClick', {
            //         'page_id': '1qjk',
            //         'courses_id':[this.courseId],
            //         'button_name': '领取详细课程大纲'
            //     });
            // } else {
            //     this.eduPlatTrack('WebButtonClick', {
            //         'page_id': '1qjk',
            //         'button_name': '领取详细课程大纲'
            //     });
            // }
            str && this.platTrackClickFn(str);
            setTimeout(() => {
                window.location.href = 'https://t.lagou.com/WR9BRRRrs05DD';
            }, 200);
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.sw1-wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.sw1-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });

                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 500 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
        rangeSwipers() {
            let option = {
                direction: 'vertical',
                loop: true,
                autoplay: 1,
                speed: 850,
                freeMode:true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 6
            };
            this.$nextTick(() => {
                const swiperDom = new Swiper('.range_list', option);
            })
        },
        platTrackClickFn(name) {
            this.platTrack('pcclick', {
                page_id: 'j1tyr',
                address_id: this.addressIdsMap[name]
            })
        }
    },
};
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    min-width: 1200PX;
    background: #EDEEFB;
    padding-bottom: 90PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .btn-img-1 {
            position: absolute;
            top: 0;
            left:0;
            width: 100%;
            height: 100%;
            background-color:transparent;
            border: none;
            z-index: 9;
        }
        .section-btn4 {
            position: absolute;
            bottom: 46PX;
            left: 50%;
            transform: translateX(-50%);
            height: 88PX;
            width: 500PX;

        }
    }
    .ceiling-view {
        width: 100%;
        height: 66PX;
        margin: 0PX auto 40PX;
        background-color: #fff;
        .ceiling-tab {
            width: 1100PX;
            margin: 0 auto;
            height: 66PX;
            background-color: #fff;
            border-radius: 2PX;
            box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
            display: flex;
            align-items: center;
            cursor: pointer;
            // transform: scale(.7);
            .tab-item {
                position: relative;
                flex: 1;
                text-align: center;
                font-size: 20PX;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #32355C;
                height: 100%;
                line-height: 66PX;
                box-sizing: border-box;
                .bor {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%);
                    width: 168PX;
                    height: 3PX;
                    border-radius: 1PX;
                    background: linear-gradient(127deg, #DCAD7F 0%, #ECC39A 100%);
                }
            }
            .active-tab {
                box-sizing: border-box;
                padding-left: 40PX;
                &::before{
                    content: '';
                    width: 24PX;
                    height: 24PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20210830/1630305549390.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 62PX;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
            }

        }
        @media screen and (max-width:1900px){
            .ceiling-tab {
                width: 940PX;
                .tab-item {
                    .bor {
                        width: 148PX;
                    }
                }
                .active-tab {
                    padding-left: 40PX;
                    &::before{
                        left: 44PX;
                    }
                }
            }
        }
        @media screen and (max-width:1500px){
            .ceiling-tab {
                width: 790PX;
                .tab-item {
                    .bor {
                        width: 140PX;
                    }
                }
                .active-tab {
                    padding-left: 30PX;
                    &::before{
                        left: 26PX;
                    }
                }
            }
        }

    }
    .ceiling-fixed {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        z-index: 30;
    }
    .sectione-main {
        width: 100%;
        min-width: 1100PX;
        margin-bottom: 100PX;
        position: relative;

        .main {
            position: relative;
            width: 1100PX;
            margin: 0 auto;
            border-radius: 16PX;
            background-color: #fff;
            // padding-bottom: 100PX;
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 80PX;
                right: 60PX;
            }
            .m {
                width: 100%;
                box-sizing: border-box;
                padding: 0 65PX 80PX;
            }
            .m-title {
                padding-top: 30PX;
                font-size: 28PX;
                font-family: SourceHanSansSC-Medium, SourceHanSansSC;
                font-weight: 400;
                color: #6469A7;
                text-align: center;
            }
            .main-icon {
                width: 688PX;
                height: 2PX;
                display: block;
                margin: 8PX auto 0;
            }
            .main-t {
                width: 100%;
                height: 50PX;
                padding-top: 35PX;
                margin-bottom: 20PX;
                .m-b {
                    float: left;
                    width: 166PX;
                    height: 46PX;
                    font-size: 24PX;
                    text-align: center;
                    line-height: 46PX;
                    border-radius: 50PX;
                    color: #6469A7;
                    background: linear-gradient(192deg, rgba(99, 137, 255, .1) 0%, rgba(108, 101, 255, .1) 100%);
                }
                .detail {
                    display: block;
                    width: 132PX;
                    height: 48PX;
                    float: right;
                }
            }
            .item {
                position: relative;
                font-size: 20PX;
                font-family: SourceHanSansSC-Light, SourceHanSansSC;
                color: #6469A7;
                margin: 10PX 20PX;
                padding-left: 15PX;
                &::after {
                    position: absolute;
                    content: '';
                    left: 0PX;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 6PX;
                    height: 6PX;
                    border-radius: 50%;
                    background: #6469A7;
                }
            }
            .modal {
                position: absolute;
                top: 190PX;
                left: 50%;
                transform: translate(-50%);
                width: 1100PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 18PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
            .jump-btn {
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: -24PX;
                width: 408PX;
                height: 68PX;
                background-color:transparent;
                border: none;
                img {
                    width: 100%;
                    display: block;
                }
            }
        }
        /deep/ .el-tabs {
            width: 1100PX;
            margin: 30PX auto 0PX;
            .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll {
                height: 96PX;
                border-top-left-radius: 16PX;
                border-top-right-radius: 16PX;
                background: linear-gradient(270deg, #25168F 0%, #25106E 100%);
            }
            .el-tabs__item {
                line-height: 96PX;
                text-align: center;
                width: 140PX;
                height: 96PX;
                padding: 0;
                font-size: 22PX;
                font-family: SourceHanSansSC-Regular, SourceHanSansSC;
                color: #fff;
                font-weight: normal;
                &:hover {
                    color: #eee;
                }
            }
            .el-tabs__nav-prev {
                top: 50%;
                color: #fff;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
            }
            .el-tabs__nav-wrap.is-scrollable {
                padding: 0 35PX;
            }
            .el-tabs__nav-next {
                top: 50%;
                color: #fff;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
            }
            .el-tabs__nav-wrap::after{
                background-color: transparent;
            }
            .el-tabs__active-bar {
                background-color: transparent;
            }
            .el-tabs__item.is-active {
                color: #fff;
                font-weight: bold;
                font-size: 25PX;
            }
        }
    }
    .sw-section {
        width: 1200PX;
        margin: 0 auto 60PX;
        /deep/ .sw-wrap {
            width: 1100PX;
            padding-bottom: 30PX;
            .swiper-slide {
                width: 840PX;
                img {
                    display: block;
                    margin: 0 auto;
                    width: 840PX;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%) linear-gradient(270deg, #25168F 0%, #25106E 100%);
                border-radius: 50%;
                opacity: .4;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%) linear-gradient(270deg, #25168F 0%, #25106E 100%);
                    opacity: 1;
                }
            }
            .swiper-button-prev {
                background: url('https://s21.lgstatic.com/growth/activity/20210908/1631081169071.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
            }
            .swiper-button-next {
                background: url('https://s20.lgstatic.com/growth/activity/20210908/1631081152307.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;

            }
        }
    }
    .sw-section1 {
        width: 100%;
        padding-top: 20PX;
        position: relative;
        height: 560PX;
        // background-color: rgba(22, 10, 83, .9);
        background-color: rgba(22, 10, 83, 1);
        /deep/ .sw1-wrap {
            // position: absolute;
            // top: 120PX;
            // left: 50%;
            // transform: translate(-50%);
            width: 1000PX;
            height: 540PX;
            .swiper-slide {
                width: 640PX;
                opacity: 0;
                img {
                    display: block;
                    width: 640PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(90deg, #fff 0%, #fff 100%);
                border-radius: 50%;
                opacity: .5;
                &-active{
                    opacity: 1;
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(90deg, #fff 0%, #fff 100%);
                }
            }
            .swiper-button-prev {
                background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354468162.png') no-repeat center;
                background-size: 100% 100%;
                width: 58PX;
                height: 58PX;
                // top: 50%;
                // transform: translateY(-50%);
                // left: 0PX;
            }
            .swiper-button-next {
                background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354439579.png') no-repeat center;
                background-size: 100% 100%;
                width: 58PX;
                height: 58PX;
                // // right: -80PX;
                // // top: 50%;
                // transform: translateY(-50%);
                // right: 0PX;
            }
        }
    }
    .sw-section2 {
        width: 100%;
        padding-top: 20PX;
        position: relative;
        height: 730PX;
        background-color: rgba(22, 10, 83, 1);
        /deep/ .sw2-wrap {
            // position: absolute;
            // top: 120PX;
            // left: 50%;
            // transform: translate(-50%);
            width: 1200PX;
            height: 720PX;
            .swiper-slide {
                width: 375PX;
                img {
                    display: block;
                    width: 375PX;
                    margin: 0 auto;
                }
            }
        }
    }
    .rank-main {
        width: 100%;
        background-color: rgba(22, 10, 83, 1);
        padding-bottom: 20px;
        .section-rank {
            width: 1080PX;
            margin: 0 auto;
            background-color: #fff;
            border-radius: 12PX;
            .title {
                width: 1080PX;
                // height: 112px;
                display: block;
                margin: 0 auto;
            }
        }
        .range_list {
            margin: 0 auto;
            width: 1040PX;
            height: 650PX;
            // position: absolute;
            // left: 50%;
            // transform: translate(-50%,0);
            // top: 280px;
        }
        /deep/ .range_list .swiper-wrapper {
            -webkit-transition-timing-function: linear;    /*之前是ease-out*/
            -moz-transition-timing-function: linear;
            -ms-transition-timing-function: linear;
            -o-transition-timing-function: linear;
            transition-timing-function: linear;
            margin: 0 auto;
        }
        .range_box {
            border-bottom: 1PX dashed #ccc;
            display: flex;
            font-size: 24PX;
            color: #666;
            height: 80PX;
            line-height: 79PX;
            box-sizing: border-box;
            box-sizing: border-box;
            .c_img {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                .company {
                    width: 118PX;
                    height: 38PX;
                    // margin-left: 106PX;
                    text-align: center;
                    display: block;
                    // margin: 20PX auto 0;
                    // margin-top: 19PX;
                }
            }

            .name {
                flex: 1;
                // margin-left: 98PX;
                text-align: center;
                opacity: .8;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .range {
                flex: 1;
                // margin-left: 138PX;
                display: flex;
                justify-content: center;
                align-items: center;
                opacity: .8;
            }
            .course_name {
                height: auto;
                flex: 1;
                // margin-left: 65PX;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #FC2727;
                font-weight: bold;
            }
        }
    }

    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: 0PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        min-width: 1200PX;
        box-shadow: 0PX -12PX 12PX 0PX rgba(156, 157, 185, 0.22);
        .img {
            width: 100%;
            display: block;
        }
        // .iconBox {
        //     position: absolute;
        //     top: -30PX;
        //     left: 50%;
        //     transform: translate(-50%);
        //     z-index: 999;
        //     width: 1160PX;
        //     .icon {
        //         float: right;
        //         width: 240PX;
        //     }
        // }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
        .img {
            width: 100%;
            display: block;
        }
        .text-loop {
          position: absolute;
          width: 215PX;
          height: 37PX;
          right: 31.5%;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          border-image-width: 0;
        }
    }

    .box {
      width: 100%;
      .box-inner {
        position: relative;
        width: 1200PX;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
      }
      &-fixed {
        position: fixed;
        bottom: 0;
        left: 0;
        height: 118PX;
        line-height: 118PX;
        background-color: #fff;
        z-index: 999;
      }
    }
    .box10-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .box10-left {
        display: flex;
        align-items: center;
        color: #A954FF;
        font-size: 26PX;
        & > img {
          width: 24PX;
          height: 24PX;
          margin-right: 12PX;
        }
      }
      .box10-right {
        width: 384PX;
        height: 68PX;
        line-height: 68PX;
        background: linear-gradient(90deg, #FF5487 0%, #FF854C 100%);
        border-radius: 39PX;
        font-size: 24PX;
        color: #fff;
        text-align: center;
      }
    }
}
</style>
